import { render, staticRenderFns } from "./RootCauseDashboard.vue?vue&type=template&id=29b7b67a&scoped=true&"
import script from "./RootCauseDashboard.vue?vue&type=script&lang=js&"
export * from "./RootCauseDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RootCauseDashboard.vue?vue&type=style&index=0&id=29b7b67a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b7b67a",
  null
  
)

export default component.exports